<script setup>
import { onMounted, reactive, ref, unref } from "vue";
import { useAuth } from "@/stores/auth";
import Notifications from "@/composables/notifications";
import {handleApiException} from "@/composables/exceptions.js";
import {t} from "i18next";
import Dialog from "@/components/modals/Dialog.vue";
import InvestmentsService from "@/services/InvestmentsService.js";

const STEP_AMOUNT = 1;
const STEP_SUCCESS = 2;

const modal = ref(null);
const step = ref(STEP_AMOUNT);

const loading = ref(false);
const amount = ref(null);

const showModal = () => {
  modal.value.show();
}

const onHide = () => {
  step.value = STEP_AMOUNT;
  amount.value = null;
}

const closeModal = () => {
  modal.value.hide();
}

const sendPurchaseRequest = async () => {
  try {
    const _value = parseInt(amount.value);
    if (isNaN(_value) || _value < 1) {
      return;
    }
    loading.value = true;
    await InvestmentsService.buyTokens({amount: _value});
    step.value = STEP_SUCCESS;
  }
  catch (e) {
    handleApiException(e);
    if (e.response && e.response.data && e.response.data.message) {
      Notifications.alert(e.response.data.message);
    }
  }
  finally {
    loading.value = false;
  }
}

defineExpose({
  showModal,
});
</script>

<template>
  <Dialog ref="modal" parent-classes="confirm-email-modal" :rounded="false" @hide="onHide">
    <div class="card p-2 rounded-0" :class="{'bg-success-subtle' : step === STEP_SUCCESS }">
      <div v-if="step === STEP_AMOUNT" class="card-body">
        <h6 class="text-center mb-3">Please enter the amount of tokens you would like to purchase</h6>
        <div class="input-group mb-3">
          <input
              v-model="amount"
              placeholder="Amount"
              autocomplete="one-time-code"
              class="form-control rounded-0"
          />
          <button class="btn btn-primary rounded-0" :disabled="loading" @click="sendPurchaseRequest">
            {{ t('header.auth.confirm') }}
          </button>
        </div>
      </div>
      <div v-else class="card-body">
        <h5 class="text-center text-success">Thank you!</h5>
        <h6 class="text-center text-success">We will contact you shortly concerning your order.</h6>
      </div>
    </div>
  </Dialog>
</template>
